import React from 'react';

const MainHeader = ({ children }) => {
  return <h2>{children}</h2>;
};

export default MainHeader;
